export default "__VITE_ASSET__xAQ6OxGs__"